import { num } from "@/lib/format";
import { AlertTriangle, ExternalLink } from "lucide-react";

const REASONS = { telefono: "stesso telefono", nome_citta: "stesso nome e città" };

export const OtherAccounts = ({ data, onSelect }) => {
  if (!data?.accounts?.length) return null;
  return (
    <div className="min-w-0 overflow-hidden rounded-md border border-amber-500/40 bg-amber-500/10 p-3 text-xs" data-testid="other-accounts">
      <p className="mb-1.5 font-semibold text-amber-500">
        <AlertTriangle className="mr-1.5 inline h-3.5 w-3.5 align-[-2px]" />Ha anche {data.accounts.length === 1 ? "un altro account" : `altri ${data.accounts.length} account`} ({data.reasons.map((r) => REASONS[r]).join(", ")})
      </p>
      {data.accounts.map((a) => (
        <div key={a.id} className="flex flex-wrap items-center justify-between gap-2 py-0.5" data-testid={`other-account-${a.id}`}>
          <button className="min-w-0 flex-1 break-words text-left hover:text-primary" onClick={() => onSelect?.(a.id)} data-testid={`other-account-open-${a.id}`}>
            <span className="font-medium">{a.name}</span> <span className="text-muted-foreground">· {a.email || "senza email"} · {num(a.orders_count)} {a.orders_count === 1 ? "ordine" : "ordini"}</span>
          </button>
          {a.shopify_url && <a href={a.shopify_url} target="_blank" rel="noreferrer" className="flex items-center gap-1 text-primary hover:underline" data-testid={`other-account-shopify-${a.id}`}>Shopify<ExternalLink className="h-3 w-3" /></a>}
        </div>
      ))}
    </div>
  );
};
